module.exports = __webpack_public_path__ + "img/logo.d536c620.png";